import { useMemo } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const sortItems = (ranking, settings) => {
  const products = [];

  for (const { item_id, item_type } of ranking.rankingPositions) {
    for (const product of (settings.lists[item_type] || settings.lists[`${item_type}s`] || settings.lists[ranking.type])) {
      if (product.mysqlId === item_id) {
        products.push(product);

        break;
      }
    }

    if (products.length === settings.limit) {
      break;
    }
  }
  
  return products;
}

const useRankings = (settings) => {
  const { allMysqlRanking } = useStaticQuery(graphql`
    query useRanking {
      allMysqlRanking(sort: { fields: mysqlId, order: DESC }) {
        nodes {
          type
          group_id
          mysqlId
          name
          url
          prefix_url
          rankingPositions {
            item_id
            item_type
            position
          }
        }
      }
    }
  `)

  return useMemo(() => {
    if (!Object.values(settings.lists).length || !settings.types) {
      return {
        rankingLists: [],
      }
    }

    const rankingLists = [];

    const match = settings.types.match(/-(\d{1})$/);
    const groupId = Array.isArray(match) ? parseInt(match[1]) : -1;

    if (settings.types === 'all') {
      for (const ranking of allMysqlRanking.nodes) {
        if (ranking.group_id) {
          rankingLists.push([ranking, sortItems(ranking, settings)]);
        }
      }
    } else {
      for (const ranking of allMysqlRanking.nodes) {
        if (
          ranking.url === settings.types || 
          ranking.mysqlId === parseInt(settings.types, 10) ||
          ranking.group_id === groupId
        ) {
          rankingLists.push([ranking, sortItems(ranking, settings)]);

          break;
        }
      }
    }

    return {
      rankingLists
    };
  }, [settings, allMysqlRanking.nodes]);
};

export default useRankings;
